'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Highcharts = _interopDefault(require('highcharts'));
var highchartsMore = _interopDefault(require('highcharts/highcharts-more'));
var solidGauge = _interopDefault(require('highcharts/modules/solid-gauge'));
var HighchartsReact = _interopDefault(require('highcharts-react-official'));
var LoadingSpinner = require('../../LoadingSpinner/LoadingSpinner.js');
var utils = require('./utils.js');

/* eslint-disable react/no-this-in-sfc */
highchartsMore(Highcharts);
solidGauge(Highcharts);
var CircleChart = function (props) {
    var subtitle = props.subtitle, innertitle = props.innertitle, _a = props.data, data = _a === void 0 ? 0 : _a, _b = props.innerRadius, innerRadius = _b === void 0 ? 85 : _b, _c = props.outerRadius, outerRadius = _c === void 0 ? 100 : _c, _d = props.backgroundColor, backgroundColor = _d === void 0 ? 'rgba(227,235,246,1)' : _d, _e = props.lineColor, lineColor = _e === void 0 ? 'rgba(48,104,253,1)' : _e, titlePosition = props.titlePosition, titleColor = props.titleColor, subTitleColor = props.subTitleColor, _f = props.height, height = _f === void 0 ? null : _f, _g = props.loading, loading = _g === void 0 ? false : _g, tooltipFormatter = props.tooltipFormatter;
    var series = utils.generateSeries();
    series[0].dataLabels.format = utils.generateTitle(innertitle, subtitle, titlePosition, titleColor, subTitleColor);
    series[0].data[0].innerRadius = innerRadius + "%";
    series[0].data[0].radius = outerRadius + "%";
    series[0].data[0].y = data;
    series[0].data[0].color = lineColor;
    var options = utils.generateOptions({
        backgroundColor: backgroundColor,
        height: height,
        series: series,
        tooltipFormatter: tooltipFormatter,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
    });
    return (React__default.createElement(LoadingSpinner, { isLoading: loading },
        React__default.createElement(HighchartsReact, { highcharts: Highcharts, options: options })));
};

module.exports = CircleChart;
